import dbList from "../DBList.json";

const {
    api_server,
    app_key
} = dbList.server;

export async function FetchAppKeys() {
    const httpRes = await fetch(`${api_server}${app_key}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}

export async function AddAppKey(AKey) {
    const httpRes = await fetch(`${api_server}${app_key}`, {
        method: "PUT",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*",
            "content-type": "application/json"
        },
        body: JSON.stringify(AKey)
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}

export async function UpdateAppKey(AKey) {
    const httpRes = await fetch(`${api_server}${app_key}`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*",
            "content-type": "application/json"
        }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }
}

export async function DeleteAppKey(AID) {
    const httpRes = await fetch(`${api_server}${app_key}/${AID}`, {
        method: "DELETE",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }
}